export function initRatingSlider() {
	const sliders = document.querySelectorAll('.rating-slider-wrapper');

	sliders.forEach(wrapper => {
		const input = wrapper.querySelector('input[type="range"]');
		const fill = wrapper.querySelector('.rating-fill');
		const thumb = wrapper.querySelector('.rating-thumb');
		const valSpan = wrapper.querySelector('.rating-val');
		const textWrapper = wrapper.querySelector('.rating-text');
		const title = wrapper.querySelector('.rating-title');
		const desc = wrapper.querySelector('.rating-desc');

		if (!input || !fill || !thumb) return;

		// Parse texts from data attribute
		const texts = JSON.parse(wrapper.dataset.texts || '{}');
		const thumbWidth = 20;

		let rAF = null;

		function updateVisuals() {
			const val = parseInt(input.value);
			const max = parseInt(input.max);

			// Special handling for 0 (unselected/initial state)
			if (val === 0) {
				fill.style.width = '0%';
				thumb.style.left = '0%';
				valSpan.textContent = '';
				textWrapper.style.opacity = '0';
				textWrapper.style.display = 'none'; // Completely hide
				return;
			}
			textWrapper.style.display = 'block';
			requestAnimationFrame(() => {
				textWrapper.style.opacity = '1';
			});

			// Calculate percentage
			const percent = (val / max) * 100;

			fill.style.width = percent + '%';

			// Thumb position
			thumb.style.left = `calc(${percent}% + (${0 - (thumbWidth * percent / 100)}px))`;

			valSpan.textContent = val + ' ' + wpcore.direct_t({ en: 'pt', fr: 'pt' });

			if (texts[val]) {
				title.textContent = texts[val].title || '';
				desc.textContent = texts[val].desc || '';
			}
		}

		function onInput() {
			if (rAF) cancelAnimationFrame(rAF);
			rAF = requestAnimationFrame(updateVisuals);
		}

		input.addEventListener('input', onInput);
		window.addEventListener('resize', onInput);

		// Initial update
		updateVisuals();
	});
}
